// src/com/veh_info/VehInfo.js
import TopViewControl from '../../common/TopViewControl';
import ServiceTabs from '../menu_info/ServiceTabs';
import { menuRequestRepo } from '../../value/AppModel';
import VehInfoOwned from './VehInfoOwned';
import VehInfoRented from './VehInfoRented';
import { AppMenuUrl } from '../../value/AppConst';

export default function VehInfo({
    menu, parentMenu
}) {
    const onChangeTab = (v) => {
        const sib = parentMenu.children.find((child) => child.menuId === v);
        menuRequestRepo({menu:sib, parentMenu:parentMenu});
    };

    const viewServiceTags = <ServiceTabs menu={menu} parentMenu={parentMenu} onChangeTab={onChangeTab} />;

    // 운송사별 고정차, 센터별 용차
    return(
        <TopViewControl>
            {
                (() => {
                    if(menu.menuUrl===AppMenuUrl.VehRegisterCom) return <VehInfoOwned viewServiceTags={viewServiceTags} />;
                    if(menu.menuUrl===AppMenuUrl.VehRegisterDC) return <VehInfoRented viewServiceTags={viewServiceTags} />;
                    return null;
                })()
            }
        </TopViewControl>
    );
}